import React from 'react'
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';

const YesNoQuestion = ({ item, setItem, validations, activeAccordion }) => {
  // let activeAccordion = 'Intake Form';
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  return (
    <div className='content-box d-flex gap-10 checkbox-multiline-alignment '>
      <p className={`text text-black w-231px flex-shrink-0 d-flex  justify-content-end gap-01 text-end ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
        {item.content || '[Enter prompt or question]'}
        {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
      </p>

      <div className="d-flex gap-20 w-100">
        <label className="ar_radio-btn d-flex gap-6">
          <input
            type="radio"
            id={`yes-${item.ItemID}`}
            name={`binary-${item.ItemID}`}
            value="Yes"
            checked={item.answer === 'Yes'}  // Controlled by state
            onChange={(e) => handleSetAnswer(e, item)}
          />
          <p className="text ar-orange-text" htmlFor={`yes-${item.ItemID}`}>Yes</p>
        </label>
        <label className="ar_radio-btn d-flex gap-6">
          <input
            type="radio"
            // type="radio"
            id={`no-${item.ItemID}`}
            name={`binary-${item.ItemID}`}
            value="No"
            checked={item.answer === 'No'}  // Controlled by state
            onChange={(e) => handleSetAnswer(e, item)}
          />
          <p className="text ar-orange-text" htmlFor={`no-${item.ItemID}`}>No</p>
        </label>
      </div>
    </div>
  );
};

export default YesNoQuestion;